import { NgModule } from '@angular/core';
import { ValidationComponent } from './validation.component';



@NgModule({
  declarations: [ValidationComponent],
  imports: [
  ],
  exports: [ValidationComponent]
})
export class ValidationModule { }
